<template>
  <transition
    name="dialog"
    @after-enter="$emit('opened')"
    @after-leave="$emit('closed')"
  >
    <Dialog
      v-if="visible"
      title="报警记录"
      width="716px"
      @close="$emit('update:visible', false)"
      :background-image="require('@/assets/popup/people.png')"
      :show-foot="false"
    >
      <div class="dialog-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <div class="label">报警时间</div>
              <span>：</span>
              <div class="value">{{ info.procesTime }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <div class="label">签收时间</div>
              <span>：</span>
              <div class="value">{{ info.signTime }}</div>
            </div>
          </el-col>
        </el-row>
        <div class="info-item">
          <div class="label">处置时间</div>
          <span>：</span>
          <div class="value">{{ info.disposeTime }}</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <div class="label">事 发 地</div>
              <span>：</span>
              <div class="value">{{ info.warningPoint }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <div class="label">区域负责人</div>
              <span>：</span>
              <div class="value">{{ info.gridName }}</div>
            </div>
          </el-col>
        </el-row>
        <div class="info-item">
          <div class="label">问题状态</div>
          <span>：</span>
          <div
            class="value"
            :style="{ color: info.statusColor }"
          >
            {{ info.statusName }}
          </div>
        </div>
        <div class="info-item">
          <div class="label">现场照片</div>
          <span>：</span>
        </div>
        <div class="img-list">
          <div
            class="image-wrapper"
            v-for="(url, index) in imgList"
            :key="index"
          >
            <el-image
              style="width: 100%; height: 100%"
              :src="url"
              fit="cover"
              :preview-src-list="imgList"
            ></el-image>
            <div class="preview">
              <div class="preview-btn">点击查看</div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </transition>
</template>

<script>
  import Dialog from "@/components/Dialog/index";
  export default {
    name: "DetailDialog",
    components: { Dialog },
    props: {
      visible: Boolean,
      info: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {};
    },
    computed: {
      imgList: ({ info }) => [info.eventImg, info.eventImg1],
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style scoped lang="less">
  .dialog-content {
    padding: 0 10px;
    .info-item {
      display: flex;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      .label {
        min-width: 80px;
        text-align-last: justify;
      }
    }

    .img-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 18px;
      min-height: 148px;
      padding: 14px 0 20px;

      .image-wrapper {
        position: relative;
        width: 100%;
        height: 148px;

        &:hover .preview {
          opacity: 1;
        }

        .preview {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.5);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.3s;

          .preview-btn {
            box-sizing: border-box;
            width: 116px;
            height: 35px;
            line-height: 33px;
            text-align: center;
            font-size: 16px;
            color: #ffffff;
            border-radius: 4px;
            border: 1px solid #ffffff;
          }
        }
      }
    }
  }
  .dialog-enter-active,
  .dialog-leave-active {
    transition: opacity 0.3s;
  }
  .dialog-enter,
  .dialog-leave-to {
    opacity: 0;
  }
</style>
